import type { FC } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import type { LastSong } from '@redux/player/types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getStyledLastSongListItemText } from './LastSongItemText.style';

interface ILastSongItemText {
  innerRef?: (element: HTMLElement | null) => any;
  lastSong?: LastSong;
}

const LastSongItemText: FC<ILastSongItemText> = ({ innerRef, lastSong }) => {
  const colors = useSelector(colorsSelector);
  const StyledLastSongListItemText = getStyledLastSongListItemText(colors)
  const innerRefProp = innerRef ? { ref: innerRef } : {};

  return (

    <StyledLastSongListItemText
      {...innerRefProp}
      primary={lastSong?.song?.title ?? <FormattedMessage id='song.noLastSongTitle' />}
      secondary={lastSong?.song?.artist?.name ?? <FormattedMessage id='song.noLastSongArtist' />}
    />
  );
};

export default LastSongItemText;
